export default {

    name: 'Name',
    return: 'Back',
    preferredLanguage: 'Preferred Language',
    languagePlaceHolder: 'Select a Language',
    noLanguage: 'Language not found',
    noLanguages: 'Languages not found',
    information: 'Information',
    description: 'Description',
    create: 'Create',
    module: 'Module',
    actions: 'Actions',
    activeText: 'Active',
    inactiveText: 'Inactive',
    details: 'Details',
    status: 'Status',
    greeting: 'Hello, ',
    cancel: 'Cancel',
    edit: 'edit',
    address: 'Address',
    category: 'Category',
    categoryPlaceHolder: 'Select a category',
    typePlaceHolder: 'Select a type',
    noCategory: 'Category not found',
    noCategories: 'Categories not found',
    warning: 'Warning',
    success: 'Success!',
    unknown: 'Unknown',
    genericError: 'An error occurred while',
    update: 'update',
    enableEdit: 'Enable to edit',
    editWarning: 'You must enable editing if you want to modify this field',
    confirmationMessage: 'Are you sure you want to continue?',
    addingMessage: 'Adding...',
    deletingMessage: 'Deleting...',
    all: 'All',
    search: 'Search...',
    noOptions: 'There are no options',
    atention: '¡Atention!',
    level: 'Level',
    correctly: 'correctly',
    updated: 'updated',
    created: 'created',
    save: 'save',
    delete: 'delete',
    loadingLabel: 'Loading Information...',
    finalized: 'Finalized',
    code: 'Code',
    start: 'Start',
    end: 'End',
    oups: '¡Ups!',
    new: 'New',
    index: 'Home',
    clearFilter: 'Clear filter',
    welcome: 'Welcome to Keru ',
    waitAlert: 'Wait!',
    noPagePermissions: 'You do not have the necessary permissions to access this page.',
    pageNotFound: 'The page you are looking for does not exist or has been deleted.',
    notFoundAlert: 'Not found!',
    filter: { single: 'Filter', plural: 'Filters' },
    applyFilter: 'Apply Filters',
    cleanFilters: 'Clean filters',
    noStatus: { single: 'Status not found', plural: 'Statuses not found' },
    one: 'A',
    imReady: 'I\'m ready to continue',
    previous: 'Previous',
    next: 'Next',
    type: 'Type',
    importCsvSuccess: 'Successful import from CSV',
    importCsvError: 'Error during import from CSV',
    importExcelSuccess: 'Successful import from excel',
    importExcelError: 'Error during import from excel',
    importTemplate: 'Import Template',
    importCsv: 'Import CSV',
    downloadTemplateCsv: 'Download CSV Template',
    pagination: 'Page {current} of {total}',
    errorOccurred: 'An error occurred',
    contactSupportWithCode: 'contact support with the code',
    importExcel: 'Import excel',
    downloadTemplateExcel: 'Download excel Template',
    validating: 'Validating...',
    generating: 'Generating...',
    desactivating: 'Deactivating...',
    followUp: 'Follow up',
    noStatuses: 'Statuses not found',
    followUps: 'Follow ups',
    date: 'Date',
    welcomeMessage: 'We are glad to have you on our <b>information security risk management platform</b>. Here you can effectively manage and protect your information',
    settings: 'Settings',
    myAccount: 'My account',
    logout: 'Logout',
    notFound: '¡Oops! The page you are looking for does not exist.',
    backHome: 'Back to home',
    selectFiles: 'Select files',
    see: 'See',
    error: 'Error',
    page: 'Page',
    downloadErrors: 'Download errors',
    downloading: 'Downloading...',
    formErrors: 'There are errors in the form, please correct them before continuing.',
    switchCompany: 'Switch organization',
    max500: 'Max. 500 characters',
    configurationGuideMesage: 'In this module, you can manage the system’s core information, including vulnerability and threat catalogs, configuration tables, and measurement values for risk analysis.',

}
